import storage from "redux-persist/lib/storage";
import hardSet from "redux-persist/lib/stateReconciler/hardSet";
import { getPersistStorageKey } from "../utils/franchise/franchiseSlug";

export const persistorConf = {
  key: getPersistStorageKey(),
  storage,
  stateReconciler: hardSet,
};
